module.exports = __webpack_public_path__ + "img/banner1-3.143b38d4.png";